<template lang="pug">
.section
  loading
  navigation(v-if="apiToken || isProfessional()")
  router-view
</template>

<script>
import Buefy from 'buefy'
import { format } from 'date-fns'
import Vue from 'vue'
import Vuelidate from 'vuelidate'
import VueTheMask from 'vue-the-mask'

import '@fortawesome/fontawesome-free/css/all.min.css'

import Loading from '@/components/Loading.vue'
import Navigation from '@/components/Navigation.vue'

import ApiMixin from '@/mixins/ApiMixin.vue'
import ServiceWorkerMixin from '@/mixins/ServiceWorkerMixin.vue'

Vue.use(Buefy, {
  defaultDatepickerMobileNative: false,
  defaultDatepickerYearsRange: [-100, +100],
  defaultDateFormatter: (date) => format(date, 'DD/MM/YYYY'),
  defaultFirstDayOfWeek: 1,
  defaultIconPack: 'fas',
  defaultTimepickerMobileNative: false
})
Vue.use(Vuelidate)
Vue.use(VueTheMask)

export default {
  components: {
    Loading,
    Navigation
  },
  mixins: [
    ApiMixin,
    ServiceWorkerMixin
  ],
  watch: {
    async apiMixinInitialised () {
      if (this.apiMixinInitialised) {
        if (!!this.$route.query?.access_token && !!this.$route.query?.expires_in && !!this.$route.query?.operator_id && !!this.$route.query?.user_id) { // eslint-disable-line camelcase
          await this.apiLogInWithToken(this.$route.query?.access_token, this.$route.query?.expires_in, this.$route.query?.operator_id, this.$route.query?.user_id) // eslint-disable-line camelcase
        }
      }
    }
  }
}
</script>

<style lang="sass">
@import "../index.sass"

@import "~bulma/sass/utilities/_all"
@import "~bulma"
@import '~bulma-tooltip'
@import "~buefy/src/scss/buefy"
@import '~vue-slider-component/lib/theme/default.scss'

.b-tabs .tab-content
  overflow: unset

.collapse-list-enter, .collapse-list-leave-to
  opacity: 0

.collapse-list-item
  transition: all 1s

.collapse-list-leave-active
  position: absolute

.display-none
  display: none

.display-none-thead
  .table-mobile-sort, thead
    display: none !important

.fas
  cursor: pointer

.image
  &.is-48x48 img
    height: 48px
    object-fit: contain
    width: 48px
  &.is-72x72 img
    height: 72px
    object-fit: contain
    width: 72px

.lowercase > input
  text-transform: lowercase

.margin-top-40
  margin-top: 40px

.notices
  .snackbar
    background: $snackbar-background-color
    .action
      .button.is-dark
        background: $snackbar-background-color
    .text
      color: $snackbar-color

.section
  padding: 0
  &.content
    padding: 8px 16px
    .pagination-list li
      list-style: none

.tooltip
  &.has-tooltip-active
    &::before
      background-color: transparent
      color: $text
      font-size: 14px
      padding: 2px 5px
    &:not(.is-loading)::after
      border-color: transparent

.visibility-hidden
  visibility: hidden

.vue-slider
  margin-top: 40px

.vue-slider-dot-tooltip-inner, .vue-slider-process
  background-color: $primary

.vue-slider-dot-tooltip-inner-top::after
  border-color: $primary

</style>
